import { START_LOADING, END_LOADING, FETCH_ALL, FETCH, CREATE, UPDATE, DELETE, WITHDRAWAL, FETCH_BY_ID, FETCH_WITH_QUERY} from '../constants/actionTypes';

const initialState = {
    withdrawal:[],
    isLoading: false,
    selectedWithdrawal:'',
};

const withdrawalReducer = (state = initialState, action) => {
    if(action?.payload?.type === WITHDRAWAL ){
        switch (action.type) {
          case START_LOADING:
            return { ...state, isLoading: true };
          case END_LOADING:
            return { ...state, isLoading: false };
          case FETCH:
          case FETCH_WITH_QUERY:
            return { ...state, withdrawal: action.payload.data };
          case FETCH_BY_ID:
            return { ...state, selectedWithdrawal: action.payload.data };
          case FETCH_ALL:
            return { ...state, withdrawal: action.payload.data };
          case CREATE:
              return {...state, withdrawal: {...state.withdrawal, withdrawals: [...state.withdrawal.withdrawals, action.payload.data]} };
          case UPDATE:
              return {...state, withdrawal: {withdrawals:state.withdrawal.withdrawals.map((withdrawal) => withdrawal._id === action.payload.data._id? {...withdrawal, ...action.payload.data}: withdrawal)}};
          case DELETE:
            return {
              ...state,
              withdrawal: {
                ...state.withdrawal,
                withdrawals: state.withdrawal.withdrawals.filter(withdrawal =>
                  Array.isArray(action.payload.data._id)
                    ? !action.payload.data._id.includes(withdrawal._id)
                    : withdrawal._id !== action.payload.data._id
                ),
                pagination: {
                  ...state.withdrawal.pagination,
                  total: Array.isArray(action.payload.data._id)
                    ? state.withdrawal.pagination.total - action.payload.data._id.length
                    : state.withdrawal.pagination.total - 1
                }
              }
            };

          default:
            return state;
        }
    }
    else{
        return state;
    }
  };
export default withdrawalReducer;